import {
  CONTENTFUL_ACCESS_TOKEN,
  CONTENTFUL_ENVIRONMENT,
  CONTENTFUL_PREVIEW_ACCESS_TOKEN,
  CONTENTFUL_SPACE_ID,
} from '../constants'

export type ContentfulAsset = {
  fields: {
    title: string
    description: string
    file: {
      url: string
      contentType: string
      fileName: string
      details: {
        size: number
        image: {
          width: number
          height: number
        }
      }
    }
  }
  metadata: {
    tags: string[]
  }
  sys: {
    createdAt: string
    environment: {
      sys: {
        id: string
        linkType: string
        type: string
      }
    }
    id: string
    locale: string
    revision: number
    space: {
      sys: {
        id: string
        linkType: string
        type: string
      }
    }
    type: string
    updatedAt: string
  }
  message?: string
}

export async function getContentfulAsset(id: string, preview: boolean) {
  const baseUrl = preview
    ? 'https://preview.contentful.com'
    : 'https://cdn.contentful.com'
  const accessToken = (
    preview ? CONTENTFUL_PREVIEW_ACCESS_TOKEN : CONTENTFUL_ACCESS_TOKEN
  ) as string

  const searchParams = new URLSearchParams({ access_token: accessToken })
  const url =
    `${baseUrl}/spaces/${CONTENTFUL_SPACE_ID}/environments/${CONTENTFUL_ENVIRONMENT}/assets/${id}?` +
    searchParams.toString()

  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), 1000)
  const data: ContentfulAsset = await fetch(url, {
    signal: controller.signal,
  }).then((data) => data.json())

  clearTimeout(timeoutId)
  if (data.sys.type === 'Error') {
    throw new Error(data.message)
  }

  return data
}
